module.exports = __webpack_public_path__ + "static/brand6-b7092b933bb3b0bcbccb67e6213888d6.png";